import { Endpoint, Http } from "Application";
import { AppUrls } from "AppUrls";

export class GETRotaByDateRequest {
    public startDate: string = "";
    public mentorStatusType?: number;
}

export class GETRotaByDateResponse {
    public mentorAvailability: any[] = [];
    public rota: any = null;
}

export class GETRotaByDateEndPoint extends Endpoint<GETRotaByDateRequest, GETRotaByDateResponse> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.WeeklyRota.GetWeeklyRotaByDate);
    }

    public async HandleRequestAsync(request: GETRotaByDateRequest): Promise<GETRotaByDateRequest> {
        return request;
    }

    public async HandleResponseAsync(response: GETRotaByDateResponse): Promise<GETRotaByDateResponse> {
        return response;
    }
}
